import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65d9a2a7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "px-5 pb-5 container" }
const _hoisted_2 = { class: "header d-flex justify-content-between align-itens-center col" }
const _hoisted_3 = { class: "m-0" }
const _hoisted_4 = { class: "container-form mb-4" }
const _hoisted_5 = { class: "form" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "form-group mb-3 w-50" }
const _hoisted_8 = { for: "name" }
const _hoisted_9 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_10 = { class: "form-group mb-3 w-25" }
const _hoisted_11 = { for: "userComputer" }
const _hoisted_12 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_13 = { class: "form-group mb-3 w-25" }
const _hoisted_14 = { for: "password" }
const _hoisted_15 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_16 = { class: "row mt-3" }
const _hoisted_17 = { class: "form-group mb-3 w-25" }
const _hoisted_18 = { for: "price" }
const _hoisted_19 = { class: "form-group mb-3 w-25" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "anydeskId" }, "Anydesk_ID", -1))
const _hoisted_21 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_22 = { class: "form-group mb-3 w-25" }
const _hoisted_23 = { for: "passwordAnydesk" }
const _hoisted_24 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_25 = { class: "form-group mb-3 w-25" }
const _hoisted_26 = { class: "d-flex gap-3 align-items-center" }
const _hoisted_27 = { class: "flex align-items-center" }
const _hoisted_28 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_29 = {
  for: "active",
  class: "mb-0 ms-2"
}
const _hoisted_30 = { class: "flex align-items-center" }
const _hoisted_31 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_32 = {
  for: "deactivated",
  class: "mb-0 ms-2"
}
const _hoisted_33 = { class: "row mt-3" }
const _hoisted_34 = {
  key: 0,
  class: "form-group mb-3 w-50"
}
const _hoisted_35 = { for: "license" }
const _hoisted_36 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_37 = {
  key: 1,
  class: "form-group mb-3 w-25"
}
const _hoisted_38 = { for: "license" }
const _hoisted_39 = {
  key: 0,
  class: "text-danger"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_ds_button = _resolveComponent("ds-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", _hoisted_3, _toDisplayString(_ctx.computerId ? _ctx.$t('computer.edit') : _ctx.$t('computer.register')), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("form", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('computer.fields.name')), 1),
            _createVNode(_component_InputText, {
              id: "name",
              name: "name",
              class: _normalizeClass(["form-control", `w-100 ${_ctx.v$.form.computer.name.$error ? 'p-invalid' : ''}`]),
              modelValue: _ctx.form.computer.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.computer.name) = $event)),
              placeholder: _ctx.$t('computer.fields.name'),
              required: ""
            }, null, 8, ["modelValue", "placeholder", "class"]),
            (_ctx.v$.form.computer.name.$error)
              ? (_openBlock(), _createElementBlock("small", _hoisted_9, _toDisplayString(_ctx.$t('utils.mandatory')), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('computer.fields.user')), 1),
            _createVNode(_component_InputText, {
              id: "userComputer",
              name: "userComputer",
              class: _normalizeClass(["form-control", `w-100 ${_ctx.v$.form.computer.userComputer.$error ? 'p-invalid' : ''}`]),
              modelValue: _ctx.form.computer.userComputer,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.computer.userComputer) = $event)),
              placeholder: _ctx.$t('computer.fields.user'),
              required: ""
            }, null, 8, ["modelValue", "placeholder", "class"]),
            (_ctx.v$.form.computer.userComputer.$error)
              ? (_openBlock(), _createElementBlock("small", _hoisted_12, _toDisplayString(_ctx.$t('utils.mandatory')), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('computer.fields.password')), 1),
            _createVNode(_component_InputText, {
              id: "password",
              name: "password",
              class: _normalizeClass(["form-control", `w-100 ${_ctx.v$.form.computer.password.$error ? 'p-invalid' : ''}`]),
              modelValue: _ctx.form.computer.password,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.computer.password) = $event)),
              placeholder: _ctx.$t('computer.fields.password'),
              required: ""
            }, null, 8, ["modelValue", "placeholder", "class"]),
            (_ctx.v$.form.computer.password.$error)
              ? (_openBlock(), _createElementBlock("small", _hoisted_15, _toDisplayString(_ctx.$t('utils.mandatory')), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('computer.fields.credits')), 1),
            _createVNode(_component_InputNumber, {
              id: "price",
              name: "price",
              min: 1,
              class: "d-block number-input",
              modelValue: _ctx.form.computer.price,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.computer.price) = $event)),
              placeholder: "Ex: 1"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createVNode(_component_InputText, {
              id: "anydeskId",
              name: "anydeskId",
              class: _normalizeClass(["form-control", `w-100 ${_ctx.v$.form.computer.anydeskId.$error ? 'p-invalid' : ''}`]),
              modelValue: _ctx.form.computer.anydeskId,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.computer.anydeskId) = $event)),
              placeholder: "Anydesk_ID",
              required: ""
            }, null, 8, ["modelValue", "class"]),
            (_ctx.v$.form.computer.anydeskId.$error)
              ? (_openBlock(), _createElementBlock("small", _hoisted_21, _toDisplayString(_ctx.$t('utils.mandatory')), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.$t('computer.fields.passAnydesk')), 1),
            _createVNode(_component_InputText, {
              id: "passwordAnydesk",
              name: "passwordAnydesk",
              class: _normalizeClass(["form-control", `w-100 ${_ctx.v$.form.computer.passwordAnydesk.$error ? 'p-invalid' : ''}`]),
              modelValue: _ctx.form.computer.passwordAnydesk,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.computer.passwordAnydesk) = $event)),
              placeholder: _ctx.$t('computer.fields.passAnydesk'),
              required: ""
            }, null, 8, ["modelValue", "placeholder", "class"]),
            (_ctx.v$.form.computer.passwordAnydesk.$error)
              ? (_openBlock(), _createElementBlock("small", _hoisted_24, _toDisplayString(_ctx.$t('utils.mandatory')), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("label", null, _toDisplayString(_ctx.$t('computer.fields.status')), 1),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createVNode(_component_RadioButton, {
                  inputId: "active",
                  name: "active",
                  value: true,
                  modelValue: _ctx.form.computer.active,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.computer.active) = $event)),
                  class: _normalizeClass(`${_ctx.v$.form.computer.active.$error ? 'p-invalid' : ''}`),
                  required: ""
                }, null, 8, ["modelValue", "class"]),
                (_ctx.v$.form.computer.active.$error)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_28, _toDisplayString(_ctx.$t('utils.mandatory')), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.$t('computer.fields.active')), 1)
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createVNode(_component_RadioButton, {
                  inputId: "deactivated",
                  name: "deactivated",
                  value: false,
                  modelValue: _ctx.form.computer.active,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.computer.active) = $event)),
                  class: _normalizeClass(`${_ctx.v$.form.computer.active.$error ? 'p-invalid' : ''}`),
                  required: ""
                }, null, 8, ["modelValue", "class"]),
                (_ctx.v$.form.computer.active.$error)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_31, _toDisplayString(_ctx.$t('utils.mandatory')), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.$t('computer.fields.inactive')), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_33, [
          (_ctx.computerId)
            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.$t('computer.fields.license')), 1),
                _createVNode(_component_AutoComplete, {
                  dropdown: "",
                  placeholder: _ctx.$t('computer.fields.select'),
                  modelValue: _ctx.pickedLicense,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.pickedLicense) = $event)),
                  suggestions: _ctx.licenses,
                  field: "licenseId",
                  onComplete: _ctx.getLicenses,
                  class: _normalizeClass(`w-100 ${_ctx.v$.form.computer.license.id.$error ? 'p-invalid' : ''}`),
                  required: ""
                }, null, 8, ["placeholder", "modelValue", "suggestions", "onComplete", "class"]),
                (_ctx.v$.form.computer.license.id.$error)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_36, _toDisplayString(_ctx.$t('utils.mandatory')), 1))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_37, [
                _createElementVNode("label", _hoisted_38, _toDisplayString(_ctx.$t('computer.fields.license')), 1),
                _createVNode(_component_AutoComplete, {
                  placeholder: _ctx.$t('computer.fields.select'),
                  modelValue: _ctx.pickedLicense,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.pickedLicense) = $event)),
                  dropdown: "",
                  suggestions: _ctx.licenses,
                  field: "licenseId",
                  onComplete: _ctx.getLicenses,
                  class: _normalizeClass(`w-100 ${_ctx.v$.form.computer.licenseId.$error ? 'p-invalid' : ''}`),
                  required: ""
                }, null, 8, ["placeholder", "modelValue", "suggestions", "onComplete", "class"]),
                (_ctx.v$.form.computer.licenseId.$error)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_39, _toDisplayString(_ctx.$t('utils.mandatory')), 1))
                  : _createCommentVNode("", true)
              ]))
        ]),
        _createVNode(_component_ds_button, {
          type: "secondary",
          text: _ctx.$t('utils.back'),
          class: "float-start me-3 button",
          onClick: _cache[10] || (_cache[10] = () => _ctx.$router.push({ name: 'Computers' }))
        }, null, 8, ["text"]),
        _createVNode(_component_ds_button, {
          type: "primary",
          text: _ctx.$t('utils.save'),
          class: "float-start button",
          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.sendComputer()))
        }, null, 8, ["text"])
      ])
    ])
  ]))
}